import type { TranslationsBase } from './ko';

const zhCN: TranslationsBase = {
  lang: 'zh-CN',
  langName: '简体中文',
  flag: '🇨🇳',

  siteTitle: '托福模考免费 — 2026新托福 | Power TOEFL',
  siteDescription: '托福模考免费练习：2026新托福3,500+题、四大板块、AI弱点分析、艾宾浩斯复习。',
  ogTitle: '托福模考免费 — 2026新托福 | Power TOEFL',

  navGrammar: '文法',
  navPractice: '分Part练习',
  navScoreChart: '分数换算表',
  navVocabulary: '单字本',
  navTips: '技巧/策略',
  navFAQ: 'FAQ',
  navReading: 'Reading',
  navListening: 'Listening',
  navSpeaking: '口语',
  navWriting: '写作',
  navQuestionPool: '题库',
  navResources: '学习资源',

  loginButton: '登录',
  wrongAnswers: '错题笔记',
  logout: '登出',
  loginRequired: '错题笔记及继续作答需要登入。',
  googleLogin: '用Google开始，解锁高级功能',

  heroBadge: '高端 TOEFL 备考系统',
  heroTitle1: '为托福高分打造的',
  heroTitle2: '唯一学习平台',
  heroDesc1: '从2026年制 Reading·Listening·Speaking·Writing 模考到错题笔记，',
  heroDesc2: '助你高效达成目标分数。',

  lcTitle: 'Listening',
  lcSubtitle: 'Listening — 47题',
  lcTime: '29分钟',
  rcTitle: 'Reading',
  rcSubtitle: 'Reading — 50题',
  rcTime: '30分钟',
  startTest: '开始测验',
  fullTestStart: '开始完整模考（Reading → Listening）',
  fullTestDesc: '依序完成两个部分',

  part1: 'Academic Reading (20)',
  part2: 'Conversations (10)',
  part3: 'Lectures (18)',

  moreTools: '更多学习工具',
  practiceLabel: '分Part练习',
  practiceDesc: 'Reading·Listening 个別学习',
  scoreChartLabel: '分数换算表',
  scoreChartDesc: '答对题数 → 换算分数',
  vocabLabel: '单字本',
  vocabDesc: '托福必备词汇',
  tipsLabel: '技巧/策略',
  tipsDesc: 'Listening·Reading攻略法',
  catLabel: 'CAT测验',
  catDesc: '根据实力自动调整难度',
  fullTestCardLabel: 'Full Test模拟考',
  fullTestCardDesc: 'Reading + Listening实战模拟',

  statQuestions: '题',
  statParts: '个Part',
  statMinutes: '分钟',

  footerMockTest: '练习',
  footerQuestionPool: '题库',
  footerPractice: '分Section练习',
  footerStudy: '学习',
  footerBooks: '推薦教材',
  footerEtc: '其他',
  footerLC: 'Listening练习',
  footerRC: 'Reading练习',
  footerSpeaking: 'Speaking练习',
  footerWriting: 'Writing练习',
  footerLCStrategy: 'Listening策略',
  footerRCStrategy: 'RC策略',
  footerCopyright: '© 2026 Power TOEFL. All rights reserved.',
  footerDisclaimer: 'TOEFL®为ETS的注冊商标。Power TOEFL与ETS无关，为独立运营的托福学习平台。',

  faqTitle: '❓ 常见问题 (FAQ)',
  faqDesc: '关于托福考试和Power TOEFL的常见问题。',
  faqPageTitle: '托福报名·分数计算·有效期限 — 2026 FAQ总整理 | Power TOEFL',
  faqPageDesc: '托福报名方法、分数换算、有效期限、分Part策略 — 30个最常见问题一页看完。',
  faqMore: '还有其他问题吗？我们持续更新FAQ。',

  scoreChartPageTitle: '托福分数换算表 2026 — 答对幾题是幾分？立即对照 | Power TOEFL',
  scoreChartPageDesc: '2026托福分数换算表。输入各科答对题数即可查看学习用预估分。2026官方成绩以1–6分为主。',
  scoreChartHeading: '📊 托福分数换算表 2026',
  scoreChartIntro: '各科0–30与总分0–120表是Power TOEFL按旧制／可比较尺度提供的学习估值。2026官方成绩单以各科及总分1–6分（每0.5分）为主。',
  scoreChartLC: 'LC（听力）换算表',
  scoreChartRC: 'RC（阅读）换算表',
  scoreChartCorrect: '答对题数',
  scoreChartConverted: '换算分数',
  scoreChartUnit: '题',
  scoreChartPointUnit: '分',
  scoreGuideTitle: '🎯 目标分数指南',
  scoreGuide900: '頂尖',
  scoreGuide900Desc: '需要LC 90+ / RC 90+答对。接近满分水准。',
  scoreGuide800: '高階',
  scoreGuide800Desc: '目标LC 80+ / RC 80+答对。高级商务英文。',
  scoreGuide700: '中高階',
  scoreGuide700Desc: '满足大部分求职条件。需要持续学习。',
  scoreGuide600: '中階',
  scoreGuide600Desc: '基础已建立。建议专攻 Reading 和 Listening。',
  scoreChartFaqTitle: '❓ 托福分数常见问题',
  scoreChartCtaTitle: '立即确认您的实力',
  scoreChartCtaDesc: '透过免费模考了解您的预估分数。',

  vocabPageTitle: '托福必背单字600个 — 中文意思·例句·分类记忆 | Power TOEFL',
  vocabPageDesc: '托福高频单字600个，分商务·人资·行销·财务·制造·日常6大类。点击看中文意思和例句，免费线上背单字。',
  vocabHeading: '📚 托福必背单字本',
  vocabIntro: '按主题分类学习托福必背单字。点击即可查看中文意思和例句。',
  vocabShowAll: '全部显示',
  vocabHideAll: '全部隐藏',
  vocabReset: '重置',
  vocabClickToReveal: '点击查看含义',
  vocabMotivation: '持续反覆学习，托福分数一定会提升！🚀',
  vocabCatNaturalScience: '自然科学',
  vocabCatSocialScience: '社会科学',
  vocabCatHumanities: '人文学',
  vocabCatLifeScience: '生命科学',
  vocabCatTechnology: '技术/工程',
  vocabCatAcademicGeneral: '学术通用',
  vocabSynonyms: '同义词',
  vocabAntonyms: '反义词',
  vocabMyWords: '我的单词本',
  vocabAddWord: '添加单词',
  vocabAddWordPlaceholder: '输入英文单词',
  vocabMyWordsEmpty: '还没有单词，试着在上方添加吧！',
  vocabDeleteWord: '删除',
  vocabLookingUp: '搜索中...',
  vocabQuizTitle: '单词测验',
  vocabQuizDesc: '测试你学过的同义词和反义词！',
  vocabQuizMode_synonym: '同义词测验',
  vocabQuizMode_antonym: '反义词测验',
  vocabQuizMode_mixed: '混合测验',
  vocabQuizClose: '关闭',
  vocabQuizNoQuestions: '此分类题目不足。',
  vocabQuizBack: '返回',
  vocabQuizResult: '测验结果',
  vocabQuizExcellent: '太棒了！🎉',
  vocabQuizGood: '做得好！再练习一下就完美了！',
  vocabQuizKeepGoing: '继续加油！💪',
  vocabQuizRetry: '再试一次',
  vocabQuizFindSynonym: '请选出以下单词的同义词',
  vocabQuizFindAntonym: '请选出以下单词的反义词',
  vocabQuizNext: '下一题',
  vocabQuizFinish: '查看结果',
  vocabQuizStart: '开始测验',

  tipsLCPageTitle: '托福听力怎么准备？LC提分攻略 Conversations·Lectures | Power TOEFL 2026',
  tipsLCPageDesc: '托福听力LC怎么拿高分？Conversations·Lectures各Part攻略法、预读技巧、常见陷阱破解。2026最新实战攻略。',
  tipsLCHeading: '🎧 托福听力攻略——怎么拿高分？',
  tipsLCIntro: '托福LC各Part的核心攻略和实战训练方法，用对策略分数就能明显提升。',
  tipsLCButton: 'LC攻略',
  tipsRCButton: 'RC攻略',
  tipsLCPractice: 'LC实战练习',
  tipsLCPracticeDesc: '学会攻略后立即用模拟题练习。',
  tipsLCStartTest: '开始LC练习',
  tipsRCPageTitle: '托福阅读时间不够怎么办？RC时间分配攻略 | Power TOEFL 2026',
  tipsRCPageDesc: '托福RC阅读做不完？Reading时间分配策略、速读技巧、双篇三篇攻略。2026最新解法。',
  tipsRCHeading: '📖 托福阅读攻略——时间不够怎么办？',
  tipsRCIntro: '托福RC的时间分配策略和各Part攻略法，掌握节奏就不会做不完。',
  tipsRCPractice: 'RC实战练习',
  tipsRCPracticeDesc: '学会攻略后立即用模拟题练习。',
  tipsRCStartTest: '开始RC练习',

  practicePartMeta: {
    '1': { title: 'TOEFL Reading 学术文章攻略 — 20题完整策略 | Power TOEFL', desc: 'TOEFL Reading 学术文章的高效阅读法。关键字扫描、推论题、摘要题攻略一次整理。' },
    '2': { title: 'TOEFL Listening 校园对话攻略 — 笔记策略 | Power TOEFL', desc: 'TOEFL Listening Conversations 核心策略。掌握教授与学生对话的目的、态度推论、笔记技巧。' },
    '3': { title: 'TOEFL Listening 讲座攻略 — 18题核心策略 | Power TOEFL', desc: 'TOEFL Listening Lectures 攻略法。掌握讲座主题、教授意图推论、举例分析以达到高分。' },
  } as Record<string, { title: string; desc: string }>,

  practicePartContent: {
    '1': {
      intro: 'TOEFL Reading 部分需阅读学术文章（约700字）并回答主题、细节、推论、词汇和摘要问题。35分钟内完成2篇文章共20题。掌握每段主题句和关键字扫描是时间管理的关键。',
      commonTypes: ['主题/目的 (What is the passage mainly about?)', '细节资讯 (According to the passage...)', '词汇题 (The word X is closest in meaning to...)', '推论题 (What can be inferred?)', '句子插入 (Insert text)', '摘要题 (Prose Summary — 选择核心3项)'],
      strategy: ['先读问题记住2~3个关键字再扫描文章', '专注每段第一句（主题句）— TOEFL学术文章多为总分结构', '词汇题依文脈判断而非字典定义', '摘要题只选核心论点而非细节'],
      recommendedFor: ['TOEFL入門者 — 建立学术阅读感觉', 'Reading 20分以上目标 — 时间分配策略必备', '推论·摘要题弱的学习者 — 题型集中训练'],
      faq: [
        { q: 'TOEFL Reading时间不够怎么办？', a: '每篇分配17~18分钟，难题先标记跳过。摘要题至少预留3分钟。' },
        { q: '词汇题遇到不认识的字怎么办？', a: '从上下文推论意思。空格前后的句子就是线索，可能与字典定义不同。' },
        { q: '摘要题(Prose Summary)怎么做？', a: '选择代表每段核心论点的3个选项，只涉及单一段落细节的是错误答案。' },
      ],
    },
    '2': {
      intro: 'TOEFL Listening Conversations 听校园对话（教授与学生、职员与学生），约3~5分钟，回答5题。重点是掌握对话目的、细节和说话者态度。',
      commonTypes: ['对话目的 (Why does the student visit the professor?)', '细节资讯 (What does the professor say about...?)', '态度/意图 (What is the student\'s attitude?)', '下一步行动 (What will the student probably do next?)'],
      strategy: ['对话开头立即掌握来訪目的', '笔记记录核心资讯（姓名、日期、条件）', '注意说话者语气和情感表达 — 态度题的关键线索', '专注对话结尾的结论和后续行动'],
      recommendedFor: ['TOEFL Listening 15分以下 — 从短对话培养感觉', '想从比Lectures容易的题型开始的学习者', '需要练习笔记技巧的学习者'],
      faq: [
        { q: 'Conversations一定要做笔记吗？', a: '是的。TOEFL在对话结束后才显示问题，只靠记忆容易遗漏细节。善用缩写和符号快速记录是关键。' },
        { q: '如何判断说话者的态度？', a: '语气（确定/不确定）、情感表达("I\'m not sure about that", "That sounds great")、重复强调是态度题的核心线索。' },
      ],
    },
    '3': {
      intro: 'TOEFL Listening Lectures 听大学讲座（约5~7分钟）回答6题。涵蓋生物学、历史、艺术、地质学等各种学术主题。掌握讲座主题、教授意图推论和举例分析是关键。',
      commonTypes: ['讲座主题 (What is the lecture mainly about?)', '教授意图 (Why does the professor mention X?)', '细节资讯 (According to the professor...)', '推论 (What does the professor imply?)', '讲座结构 (How does the professor organize the lecture?)'],
      strategy: ['讲座前1~2分钟掌握主题和目的 — 最基本的题型', '随时思考教授举例的原因 — "Why does the professor mention X?"的核心', '转换语(Now, let\'s move on to...)标示新子题开始', '推论教授的反语、幽默和修辞问句的含义'],
      recommendedFor: ['TOEFL Listening 20分以上目标 — Lectures是分数关键', '听学术讲座感到困难的学习者', '想建立笔记系统的学习者'],
      faq: [
        { q: '"Why does the professor mention X?"怎么做？', a: '教授提到例子/比喻/实验通常是为了补充或对比之前的概念。在提及前的上下文中找目的。' },
        { q: 'Lectures沒有背景知识会吃虧吗？', a: '不会。TOEFL在讲座中提供所有必要资讯。背景知识有帮助，但讲座内容足以回答所有问题。' },
      ],
    },
  } as Record<string, { intro: string; commonTypes: string[]; strategy: string[]; recommendedFor: string[]; faq: { q: string; a: string }[] }>,

  practiceRelatedLinks: '📌 相关学习内容',
  practiceOtherParts: '其他Part攻略',
  practiceMockTestCTA: '用模拟考练习',
  practiceTipsLink: '查看Part策略',
  practiceGrammarLink: '学习文法',

  practiceNotFound: '找不到該Part。',
  practiceQuestionType: '题型',
  practiceTips: '💡 攻略技巧',
  practiceExamples: '📝 范例题',
  practiceIntro: '📋 Part介绍',
  practiceCommonTypes: '📊 常见题型',
  practiceStrategy: '🎯 攻略要点',
  practiceRecommendedFor: '👤 推薦对象',
  practiceFAQ: '❓ 常见问题',
  practiceCTA: '立即开始练习',
  practiceCTADesc: '在和实际考试相同的环境中练习Part {0}。',
  practiceStartTest: '开始{0}模拟考',
  practiceQuestions: '题',
  practicePartSelect: '选择Part',

  roundsTitle: '模拟考回次',
  roundLabel: 'TOEFL模拟考',
  roundUnit: '回',
  comingSoon: '即将推出',

  testPrevious: '上一题',
  testNext: '下一题',
  testQuestion: '题目',
  testQuestionPrompt: '请看题目选出正确答案。',
  testMarkAnswer: '请选择正确的答案。',
  testSelect: '选择',
  testShowAnswer: '查看答案与解析',
  testCorrect: '答对了！',
  testIncorrect: '答错了。',
  testLoginPrompt: '错题笔记及继续作答需要登入。',
  testGoogleLogin: '用Google 3秒开始',
  roundSelect: '选择其他回次',
  testAnswered: '已作答',
  testSubmit: '提交测验',
  testSubmitTitle: '要提交{0}测验吗？',
  testSubmitDesc: '{0}题中已回答{1}题。',
  testUnanswered: '{0}题未作答。',
  testCannotUndo: '此操作无法取消。',
  testContinue: '继续作答',
  testSubmitBtn: '提交',

  resultsTitle: '{0}测验结果',
  resultsTimeUsed: '用时：{0}分{1}秒',
  resultsEstimatedScore: '预估分数（满分30）',
  resultsCorrect: '答对',
  resultsIncorrect: '答错',
  resultsAccuracy: '正确率',
  resultsReview: '检视答案',
  resultsYourAnswer: '我的答案：{0}',
  resultsCorrectAnswer: '正确答案：{0}',
  resultsNoAnswer: '未作答',
  resultsHome: '首页',
  resultsWrongNotes: '错题笔记',
  resultsRetry: '重新测验',
  resultsShare: '分享结果',
  resultsShareText: '我的TOEFL {0}预估分数是{1}分！（{2}/{3}答对，正确率{4}%）在Power TOEFL免费测试你的实力！',
  resultsShareCopied: '结果已复制到剪貼簿！',
  resultsNoResults: '沒有测验结果。',
  resultsGoHome: '回首页',
  resultsSaved: '{0}题错题已存到错题笔记',

  wrongAnswersTitle: '错题笔记',
  wrongAnswersSaved: '已储存题目',
  wrongAnswersHome: '首页',
  wrongAnswersPracticeAll: '全部练习',
  wrongAnswersAll: '全部',
  wrongAnswersNoItems: '还沒有错题。先参加测验吧！',
  wrongAnswersYourAnswer: '我的答案：{0}',
  wrongAnswersCorrectIs: '正确答案：{0}',
  wrongAnswersReviewed: '已复习',
  wrongAnswersRemoved: '已从错题笔记删除',
  wrongAnswersPracticeMode: '练习模式',
  wrongAnswersCorrectMsg: '答对了！',
  wrongAnswersIncorrectMsg: '答错了。正确答案：{0}',
  wrongAnswersNextQuestion: '下一题',
  wrongAnswersFinish: '完成',
  wrongAnswersExitPractice: '离开练习',
  wrongAnswersPracticeComplete: '练习完成！',
  wrongAnswersNoPractice: '沒有可练习的错题',
  wrongAnswersLimitNotice: '仅显示最近500条错题。',

  privacyPageTitle: '隐私权政策 — Power TOEFL',
  privacyPageDesc: 'Power TOEFL隐私权政策。',
  privacyHeading: '隐私权政策',
  privacyLastUpdated: '最后更新：2026年3月29日',
  privacyS1Title: '1. 收集的个人资讯',
  privacyS1Body: 'Power TOEFL在Google登入时收集电子郵件、姓名、个人照片。付款资讯透过Dodo Payments/PayPal处理。',
  privacyS2Title: '2. 使用目的',
  privacyS2Body: '收集的资讯用于错题笔记、学习进度管理、订阅管理和服务改善。',
  privacyS3Title: '3. 保存与删除',
  privacyS3Body: '帳号注销时资讯将立即删除。付款记录依税法保留最多5年。',
  privacyS4Title: '4. 第三方提供',
  privacyS4Body: '仅为付款处理向Dodo Payments/PayPal提供电子郵件。',
  privacyS5Title: '5. Cookie与广告',
  privacyS5Body: '本站使用Google AdSense及相关Cookie。可在浏览器设定中管理Cookie。',
  privacyS6Title: '6. 国际资料传输',
  privacyS6Body: '资料可能透过海外伺服器进行国际传输，并採取适当安全措施。',
  privacyS7Title: '7. 使用者权利',
  privacyS7Body: '使用者可随时要求存取、更正或删除个人资讯。',
  privacyS8Title: '8. 联系方式',
  privacyS8Body: '联系：skdaks0731@gmail.com',

  termsPageTitle: '服务条款 — Power TOEFL',
  termsPageDesc: 'Power TOEFL服务条款。',
  termsHeading: '服务条款',
  termsLastUpdated: '最后更新：2026年3月29日',
  termsS1Title: '1. 服务概述',
  termsS1Body: 'Power TOEFL是提供免费和付费（Pro/Lifetime）托福考试准备的线上学习平台，由 ddookddak（我们注册的合法企业名称）运营。',
  termsS2Title: '2. 使用条件',
  termsS2Body: '年满14岁即可使用。部分功能需要Google帳号登入。',
  termsS3Title: '3. 智慧财产权',
  termsS3Body: '网站内容（题目、设计、程式码）归Power TOEFL所有。TOEFL为ETS的注冊商标。',
  termsS4Title: '4. 付款',
  termsS4Body: '付费订阅透过Dodo Payments/PayPal处理。价格可能包含增值税。',
  termsS5Title: '5. 免責聲明',
  termsS5Body: '模拟考分数为估算值，不保证实际TOEFL考试结果。',
  termsS6Title: '6. 禁止行为',
  termsS6Body: '禁止复制/散布题目、对系统造成过度負擔、与他人共享帳号。',
  termsS7Title: '7. 服务变更',
  termsS7Body: '服务可能在不事先通知的情況下变更或停止。',
  termsS8Title: '8. 取消订阅',
  termsS8Body: '订阅可随时取消。取消后可继续使用至付费期间结束。',
  termsS9Title: '9. 条款变更',
  termsS9Body: '条款可能变更并在网站公告。继续使用视为同意变更后的条款。',

  refundPageTitle: '退款政策 — Power TOEFL',
  refundPageDesc: 'Power TOEFL付费订阅退款政策。',
  refundHeading: '退款政策',
  refundLastUpdated: '最后更新：2026年4月15日',
  refundS1Title: '1. 退款原则',
  refundS1Body: '由于数字商品特性，原则上不支持退款。',
  refundS2Title: '2. 例外退款情形',
  refundS2Body: '但在法律要求、重复扣费、服务未提供或重大技术故障等情形下，可能会例外处理退款。',
  refundS3Title: '3. 联系方式',
  refundS3Body: '如有退款相关问题，请通过支持/反馈渠道联系。联系方式：skdaks0731@gmail.com',
  refundS4Title: '4. 订阅取消',
  refundS4Body: '付费订阅可随时取消。取消后仍可使用至当前计费周期结束，之后不再产生额外扣费。',
  refundS5Title: '',
  refundS5Body: '',
  refundS6Title: '',
  refundS6Body: '',

  footerPrivacy: '隐私权',
  footerTerms: '服务条款',
  footerRefund: '退款政策',
  footerAbout: '关于我们',
  footerGuide: '学习指南',
  guideLabel: '学习指南',
  guideDesc: '技巧攻略、分数策略、考试比较资讯',

  aboutPageTitle: '托福线上模考 + AI弱点分析 — 认识Power TOEFL',
  aboutPageDesc: '2026年TOEFL iBT形式练习、AI弱点分析、错题自动复习。了解Power TOEFL提供什么。',
  aboutHeading: 'Power TOEFL — 托福实战模拟学习平台',
  aboutS1Title: '什么是Power TOEFL？',
  aboutS1Body: 'Power TOEFL是面向TOEFL iBT考生的在线练习平台，提供2026年修订形式的分项练习、AI反馈和错题本。内容为自主编写的学习材料，不是ETS官方试题。',
  aboutS2Title: '适合哪些人？',
  aboutS2Body: '正在准备托福的大学生、需要达到目标分数的上班族、准备海外就业或转职者，以及所有自学托福的人。',
  aboutS3Title: '主要功能',
  aboutFeature1: '2026年制 Reading·Listening·Speaking·Writing 模考',
  aboutFeature2: 'Reading·Listening·Speaking·Writing练习',
  aboutFeature3: 'AI依难度出题 & 弱点分析',
  aboutFeature4: '错题自动储存 + 遗忘曲线复习',
  aboutFeature5: '分数换算表及托福必背单字本',
  aboutS4Title: '免费版 vs 进階版',
  aboutS4Body: '免费：模拟考、分Part练习、分数换算表。进階(Pro)：AI无限出题、无广告、全部回次。',
  aboutS5Title: '为什么有效？',
  aboutS5Body: '遗忘曲线复习和分项弱点分析帮助反复练习。分数提升取决于起点、练习量和考试当天状态，不保证特定涨幅。',
  aboutS6Title: '与ETS的关係',
  aboutS6Body: 'Power TOEFL与ETS无关联。TOEFL®为ETS的注冊商标。',
  aboutS7Title: '联系方式',
  aboutS7Body: '联系：skdaks0731@gmail.com',
  aboutCtaHeading: '立即开始',
  aboutCtaDesc: '免费试做实战模拟考。',
  aboutCtaStart: '开始模考',
  aboutCtaPricing: '查看Premium方案',

  resumeTest: '继续作答',
  resumeDesc: '{0} 第{1}回 — {2}/{3}题',
  progressLabel: '进度',
  timerLabel: '剩余时间',
  timeUp: '时间到！',

  navHome: '首页',
  navSettings: '技巧',

  grammarSectionTitle: '托福语法书',
  grammarSectionDesc: '系统化学习托福必考文法',
  grammarViewAll: '查看全部',
  grammarChapter: '章节',

  aiPracticeTitle: 'AI托福题目无限生成 — 选Part·难度立即出题 | Power TOEFL',
  aiPracticeDesc: '选择Part和难度，AI立即生成托福题目。每天练习新题目。',
  aiPracticeH1: '✨ AI托福出题',
  aiPracticeSub: 'AI根据你的程度即时生成托福题目。',
  aiPartLabel: 'Part',
  aiDiffLabel: '难度',
  aiBeginner: '初级（1.0–2.5）',
  aiIntermediate: '中级（3.0–4.5）',
  aiAdvanced: '高级（5.0–6.0）',
  aiGenerate: '生成题目',
  aiGenerating: '生成中...',
  aiRemainingToday: '本月剩余{0}次',
  aiLimitReached: '本月AI额度已用完',
  aiLimitUpgrade: '加购额度或升级方案！',
  aiUpgrade: '升级',
  aiListenPrompt: '🔊 LC题目请邊听邊作答',
  aiPlayAudio: '播放音讯',
  aiStopAudio: '停止',
  aiCorrect: '✅ 答对了！',
  aiWrong: '❌ 答错了。',
  aiCorrectAnswer: '正确答案：{0}',
  aiPrev: '上一题',
  aiNext: '下一题',
  aiNewQuestions: '新题目',
  aiEmptyTitle: '用AI生成题目',
  aiEmptyDesc: '选择Part和难度后点击「生成题目」。',
  aiLoadingMain: 'AI正在生成和验证题目...',
  aiLoadingSub: '约需10~20秒',

  statsTitle: '托福学习统计 — Power TOEFL',
  statsDesc: '文法测验正确率、错题笔记复习状态一览。',
  statsH1: '📊 学习统计',
  statsLoginPrompt: '登入后可查看学习统计。',
  statsTotalQuizzes: '总测验数',
  statsTotalQuestions: '总题数',
  statsAccuracy: '正确率',
  statsLast7Days: '最近7天',
  statsWrongSummary: '错题笔记状态',
  statsViewAll: '查看错题笔记',
  statsTotalWrong: '总错题',
  statsReviewed: '已复习',
  statsPending: '未复习',
  statsTopicAccuracy: '文法主题正确率',
  statsAttempts: '{0}次',
  statsEmpty: '尚无学习记录。试试文法测验！',
  statsStartGrammar: '开始文法学习',

  pricingTitle: '免费不够用？ — Power TOEFL Pro（月付￥128）| 托福备考效率翻倍',
  pricingDesc: '免费版每天10题（未登录3题）+ 每月1次完整模考。Pro无限练习、解析、AI反馈、去广告。月付￥128。',

  testLCTitle: '托福Reading模考免费 — 学术文章阅读 | 2026',
  testLCDesc: '2026年托福Reading模考免费练习。学术文章，错题自动保存。',
  testRCTitle: '托福Listening模考免费 — 对话·讲座听力 | 2026',
  testRCDesc: '2026年托福Listening模考免费练习。对话与讲座，附AI解析。',

  reviewTitle: '今日复习',
  reviewDesc: '基于遗忘曲线的智慧复习系统',
  reviewSubtitle: '在最佳时机根据遗忘曲线复习',
  reviewRemaining: '剩余复习',
  reviewProgress: '复习进度',
  reviewCompleted: '🎉 今日复习完成！',
  reviewCompletedDesc: '已复习{0}题',
  reviewEmpty: '今天沒有需要复习的题目',
  reviewEmptyDesc: '全部复习完成或尚无错题。',
  reviewStage: '第{0}階段',
  reviewNextInterval: '{0}天间隔',
  reviewCorrect: '答对！进入下一階段。',
  reviewWrong: '答错。回到第1階段。',
  reviewNextReview: '下次复习：{0}天后',
  reviewResetMsg: '答错，1天后再次复习。',
  reviewNext: '下一题',
  reviewFinish: '完成',
  reviewHowItWorks: '遗忘曲线复习原理',
  reviewDaysLater: '{0}天后',
  reviewExplanation: '错题以1→3→7→14→30→60天间隔复习。答对进入下一階段，答错回到第1階段。',

  notifTitle: '通知',
  notifEmpty: '沒有新通知',
  notifMarkAllRead: '全部已读',
  timeJustNow: '刚刚',
  timeMinutes: '{0}分钟前',
  timeHours: '{0}小时前',
  timeDays: '{0}天前',
  scoreCardEstimated: '预估分数',
  scoreCardCorrect: '正确',
  scoreCardIncorrect: '错误',
  scoreCardAccuracy: '正确率',

  pushTitle: '开啟学习提醒',
  pushDesc: '接收复习时间、连续学习记录等通知。',
  pushEnable: '开啟',

  navReview: '复习',
  navStats: '统计',
  navPremium: '高级版',
  navSubscription: '订阅管理',
  roundDetailHeading: 'TOEFL实战模拟考',
  roundDetailOtherRounds: '查看其他回次',
  roundSuffix: '回',

  footer7DayPlan: '7天读书法',
  footerTrapPatterns: '陷阱模式',

  pwaAddToHome: '📱 加到主畫面',
  pwaAddToHomeDesc: '像App一樣啟动！离线也能学习',
  pwaInstall: '安裝',
  pwaIOSGuide: '分享 → 加入主畫面',

  aiQuizTitle: '🤖 AI客制化练习题',
  aiQuizDesc: 'AI生成的TOEFL Grammar题目',
  aiQuizGenerateDesc: 'AI根据文法主题即时生成5题TOEFL Grammar風格题目。',
  aiQuizGenerate: '生成AI题目',
  aiQuizGenerating: '🤖 AI正在生成题目...',
  aiQuizGeneratingTime: '约需5~10秒',
  aiQuizNew: '新题目',
  aiQuizStats: '累计统计：',
  aiQuizTimes: '次',
  aiQuizCheckAnswers: '确认答案',
  aiQuizPerfect: '🎉 全部答对！',
  aiQuizCorrectCount: '答对',
  aiQuizSaving: '储存结果中...',
  aiQuizTryNew: '试新题目',
  aiQuizError: 'AI题目生成失敗。请重试。',

  tipsDetailStrategy: '详细策略',
  tips7DayTitle: '🗓️ 考前7天读书法',
  tips7DayDesc: '用最后冲刺提升分数',
  tipsTrapTitle: '⚠️ 陷阱答案模式总整理',
  tipsTrapDesc: '提前识破5大常见陷阱',

  pricingSaveBadge: '省30%',
  pricingPerMonth: '月',
  pricingSSL: '安全付款',
  pricingCurrentPlan: '目前方案',
  pricingFaqQ1: '免费和 Pro 有什么不同？',
  pricingFaqA1: '免费方案包含 Reading·Listening 基本题目和每日1次 AI 练习。Pro 包含无限 AI 模拟考、Speaking·Writing AI 批改、4技能弱点分析和去广告。',
  pricingFaqQ2: '可以退款吗？',
  pricingFaqA2: '由于数字商品特性，原则上不支持退款。但在法律要求、重复扣费、服务未提供或重大技术故障等情形下，可能会例外处理退款。',
  pricingFaqQ3: '如何取消订阅？',
  pricingFaqA3: '您可以随时在「我的订阅」页面取消。取消后仍可使用至到期日。',
  pricingFaqQ4: 'Lifetime 和 Pro 年缴有什么不同？',
  pricingFaqA4: 'Lifetime 一次付款永久使用。Pro 年缴每年需要续约。',
  proBadgeLabel: 'Pro',
  pricingCard: '信用卡',
  pricingPaymentSuccess: '进階会员啟用成功！',
  pricingPaymentCancelled: '付款已取消。',
  pricingLoginRequired: '需要登入。',
  pricingPaymentError: '付款建立失敗。',

  subLoginRequired: '需要登入。',

  grammarSystematic: '系统化文法学习',
  grammarBookTitle: '托福文法书',
  grammarBookDesc: '系统化学习20个托福必考文法主题。每章含实战例句和练习题，学完立即测验。',
  grammarTestAfter: '学完文法立刻测验！',
  grammarTestAfterDesc: '看看学到的文法在托福考试中怎么出题',
  grammarMockTest: '模拟考',
  grammarDoneTitle: '文法学完了吗？',
  grammarDoneDesc: '在模拟考中实际运用吧！错题会自动储存！',
  grammarStartRC: '开始RC模拟',
  grammarPracticePart5: 'Grammar练习',
  grammarCourseName: '托福英文法完整整理',
  grammarBreadcrumb: '文法书',

  grammarHome: '首页',
  grammarExamples: '实战例句',
  grammarTestKnowledge: '📝 实力测验',
  grammarTestKnowledgeDesc: '练习剛学过的文法相关实战题！',
  grammarCheckAnswers: '确认答案',
  grammarPerfect: '🎉 全部答对！',
  grammarCorrectCount: '答对',
  grammarMockCTA: '🔥 用模拟考验证实力！',
  grammarMockCTADesc: 'RC 100题模拟考 + 错题笔记自动生成',
  grammarStartRCMock: '开始RC模拟考',
  grammarPractice5: 'Grammar练习',
  grammarTestInPractice: '在实战中确认！',
  grammarTestInPracticeDesc: '看看文法要点在TOEFL中怎么出题。',
  grammarRelated: '📚 推薦一起看的文法',

  wrongAnswersGrammarAI: '文法AI',

  streakDays: '天',
  streakLabel: '连续学习',
  streak7: '连续学习1週！',
  streak14: '连续2週达成！',
  streak30: '太厲害了！连续1个月！',
  reviewItems: '题',
  reviewTodayLabel: '今日需复习题目',
  reviewGoLabel: '📚 去复习 →',

  leaderboardTitle: '学习排名',
  leaderboardWeekly: '週排名',
  leaderboardMonthly: '月排名',
  leaderboardLoading: '載入中...',
  loadingQuestions: '載入题目中...',
  leaderboardEmpty: '本{period}尚无资料',
  leaderboardEmptyWeek: '週',
  leaderboardEmptyMonth: '月',
  leaderboardHint: '完成测验自动登入排名！',
  leaderboardRank: '排名',
  leaderboardNickname: '暱稱',
  leaderboardSolved: '题数',
  leaderboardAccuracy: '正确率',
  leaderboardMe: '我',
  leaderboardMyRank: '🏅 我的排名：第{rank}名',

  tipsCoreTips: '核心攻略',
  tipsStrategy: '实战策略',
  tipsCTA: '学会策略了吗？开始实战！',

  testScrollHint: '捲动查看题目和选项',
  testPart1Label: 'Academic Reading',
  testPart2Title: 'Conversations',
  testPart2Desc: '听音讯选择答案',
  testPart3Label: 'Lectures',

  creditBuyBtn: '购买点数',
  creditBuyTitle: '购买 AI 点数',
  creditBuyDesc: '购买额外点数用于 Speaking/Writing AI 回饋和 AI 练习。',
  creditBuyError: '无法开始付款',
  creditBuyNote: '透过 PayPal 付款。付款完成后立即新增点数。',
  creditUnit: '点数',

  speakingPageH1: 'TOEFL Speaking 练习 2026',
  speakingPageSub: '{count}+ 免费 Speaking — Listen and Repeat · Interview',
  speakingPageTitle: 'TOEFL Speaking 练习 2026 — {count}+ 免费题目 | Power TOEFL',
  speakingPageDesc: 'TOEFL Speaking 练习题 {count}+。范例答案、评分标准、AI反馈。2026最新。',
  speakingAllTasks: '全部',
  speakingNoPrompts: '暂无 Speaking 题目',
  speakingNoPromptsSub: '题目正在生成中，请稍后再查看！',
  speakingResponseTime: '作答时间',

  writingPageH1: 'TOEFL Writing 练习 2026',
  writingPageSub: '{count}+ 免费 Writing — Build a Sentence · Email · Academic Discussion',
  writingPageTitle: 'TOEFL Writing 练习 2026 — {count}+ 免费题目 | Power TOEFL',
  writingPageDesc: 'TOEFL Writing 练习 {count}+。范例答案、评分标准。2026最新。',
  writingAllTasks: '全部',
  writingNoPrompts: '暂无 Writing 题目',
  writingNoPromptsSub: '题目正在生成中，请稍后再查看！',

  catPageTitle: 'TOEFL 适应性测试 (CAT) — AI 自动调整难度 | Power TOEFL',
  catPageDesc: 'TOEFL 计算机自适应练习测试。AI 根据正确率自动调整难度。',
  catHeading: 'Adaptive Test (CAT)',
  catIntro: '根据正确率自动调整难度。每次 {count} 题。',
  catNote: "ℹ️ 注意：真实的 TOEFL iBT 是线性（非自适应）考试。此 Practice CAT 是一款根据你的表现调整难度、帮助你快速了解自身水平的学习工具，并非真实考试形式的模拟。",
  catSelectSection: '选择科目',
  catStartBtn: '开始 Adaptive Test',
  catLoading: '加载下一题中...',
  catNoMore: '没有更多题目了',
  catComplete: 'Adaptive Test 完成',
  catAccuracy: '正确率',
  catFinalLevel: '最终难度',
  catTryAgain: '再试一次',
  catViewResults: '查看结果',
  catNext: '下一题',
  catExplanation: '解析',
  catStop: '停止',
  catPlayAudio: '🔊 播放音频',
  catReadingPassage: 'Reading Passage',

  scoreReadingHeader: 'Reading (0~30分)',
  scoreListeningHeader: 'Listening (0~30分)',
  scoreSpeakingHeader: 'Speaking (0~30分)',
  scoreWritingHeader: 'Writing (0~30分)',
  scoreSpeakingDesc: '4项任务以0~4分评分后换算为30分',
  scoreWritingDesc: '2项任务以0~5分评分后换算为30分',
  scoreSpeakingLevels: [
    ['4分 (Good)', '27~30分', '流畅准确的回答，逻辑清晰'],
    ['3分 (Fair)', '19~26分', '大致清楚但有部分错误'],
    ['2分 (Limited)', '11~18分', '基本沟通但受限'],
    ['1分 (Weak)', '1~10分', '难以传达意义'],
  ] as [string, string, string][],
  scoreWritingLevels: [
    ['5分 (Good)', '27~30分', '逻辑清晰具体的文章，语法正确'],
    ['4分 (Fair)', '22~26分', '整体不错但有不足'],
    ['3分 (Limited)', '15~21分', '有基本结构但展开不足'],
    ['2分 (Weak)', '8~14分', '偏离主题或结构不清'],
    ['1分 (Very Weak)', '1~7分', '几乎无法传达意义'],
  ] as [string, string, string][],
  scoreGuideDescs: [
    '需要 Reading 28+ / Listening 28+ / Speaking 26+ / Writing 26+。可申请顶尖大学。',
    '目标 Reading 22+ / Listening 22+。符合大多数大学入学标准。',
    '基础学术英语水平。可条件式入学。需要集中学习。',
    '基础阶段。建议集中 Reading 和 Listening。',
  ],
  // --- Flashcard mode ---
  vocabFlashcardStart: "开始闪卡记忆",
  vocabFlashcardStop: "停止闪卡",
  vocabFlashcardEmpty: "请先添加单词再开始闪卡。",
  vocabFlashcardSpeed: "速度",
  vocabFlashcardSpeedSlow: "慢速",
  vocabFlashcardSpeedNormal: "正常",
  vocabFlashcardSpeedFast: "快速",
  vocabFlashcardShuffle: "打乱",
  vocabFlashcardPrev: "上一个",
  vocabFlashcardNext: "下一个",
  vocabFlashcardFlip: "翻转",
  vocabFlashcardProgress: "{current} / {total}",
};

export default zhCN;

